import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { AuthShell, authInputClass, authSubmitClass } from '../lib/authUi';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (!email) { setError('Please enter your email address'); return; }
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://supplypilot.alchemy-byfusion.com/change-password',
    });
    if (error) { setError(error.message); setLoading(false); return; }
    setSent(true);
    setLoading(false);
  };

  return (
    <AuthShell>
      <form onSubmit={handleSubmit} className="relative w-full max-w-md">
        <div className="bg-white/95 border border-line rounded-2xl shadow-2xl overflow-hidden backdrop-blur-sm">

          <div className="px-10 pt-10 pb-8">
            <div className="text-center mb-8">
              <p className="font-['Metropolis'] text-[11px] font-bold tracking-[5px] uppercase text-fusion-forest mb-3">
                Fusion 2K
              </p>
              <h1 className="fusion-h1 text-ink">
                Reset Password
              </h1>
            </div>

            {sent ? (
              <div className="text-center py-4">
                <p className="font-['Metropolis'] text-lg font-bold tracking-[2px] uppercase text-fusion-forest mb-2">Email Sent!</p>
                <p className="font-['Metropolis'] text-sm text-fusion-mid-grey mb-6">Check your inbox for a password reset link. It may take a few minutes to arrive.</p>
                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="font-['Metropolis'] text-xs text-fusion-mid-grey hover:text-active-green transition-colors"
                >
                  Back to Login
                </button>
              </div>
            ) : (
              <div className="space-y-4">
                <p className="font-['Metropolis'] text-sm text-fusion-mid-grey mb-2">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className={authInputClass}
                />

                {error && (
                  <div className="bg-[#E0290A]/10 border border-[#E0290A]/30 px-4 py-3 rounded-xl">
                    <p className="font-['Metropolis'] text-sm text-[#E0290A]">{error}</p>
                  </div>
                )}

                <button
                  type="button"
                  onClick={() => navigate('/')}
                  className="block ml-auto font-['Metropolis'] text-xs text-fusion-mid-grey hover:text-active-green transition-colors"
                >
                  Back to Login
                </button>
              </div>
            )}
          </div>

          {!sent && (
            <button type="submit" disabled={loading} className={authSubmitClass}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          )}
        </div>
      </form>
    </AuthShell>
  );
}
